export function isTest() {
  return process.env.NODE_ENV === 'test' || ~navigator.userAgent.indexOf('Puppeteer');
}
